import { FOOTER_TYPE } from '@/core/values/core.values';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
class EdFooter extends Vue {
  
  get hasFooter() {
    return this.$store.state.AppStore.footer.type !== FOOTER_TYPE.NONE;
  }

  get compact() {
    return this.$store.state.AppStore.footer.type == FOOTER_TYPE.COMPACT;
  }

}

export default Vue.component('ed-footer', EdFooter);